export default "__VITE_ASSET__c8ca5401__"